import React, { useCallback, useState } from 'react'
import { NavLink } from '@remix-run/react'

import { getProfileUrl } from '../../../../utilities/userUtils'
import { UserProfile } from '../../../../graphql/fragments/userDetails.fragment'
import { HeaderButton, MenuButton } from '../HeaderButton'
import { Popover } from '../../../Popover'
import { SelectProfilesList } from './SelectProfilesList'
import * as styles from './ProfileButton.styles'

export let OverflowMenu: React.FC = () => {
  let [isOpen, setIsOpen] = useState(false)
  let toggle = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={toggle}
      button={<MenuButton isOpen={isOpen} toggle={toggle} />}
    >
      <HeaderButton
        label="Settings"
        route="/settings/account"
        iconName="fa fa-cog"
        composeCss={styles.headerButton}
      />
      <SelectProfilesList buttonCss={styles.headerButton} />
    </Popover>
  )
}

export let SelectedProfileLink: React.FC<{
  profile?: UserProfile
  composeCss?: Style
}> = ({ profile, composeCss }) => {
  if (!profile || profile.__typename === 'User') {
    return null
  }

  return (
    <NavLink
      prefetch="render"
      to={getProfileUrl(profile)}
      css={[styles.link, composeCss]}
    >
      {profile?.picture && <div css={styles.thumbnail(profile.picture)} />}
      <span>{profile?.name}</span>
    </NavLink>
  )
}
